module.exports = __webpack_public_path__ + "static/media/19.08931a12.jfif";